import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../service/udnick';

export const EmissorNotaServices = {
  getEmitentes: (
    inscricoesEstaduais: any,
    centroDistribuicao: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService('getEmitentes', { inscricoesEstaduais, centroDistribuicao }),
};
